import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Section3 = () => {
  const { t, i18n } = useTranslation();


  return (
    <div
      style={{
        minHeight: '60vh',
        position: 'relative',
      }}
    >
      <div
        style={{
          background: 'linear-gradient(320deg, #49AF57 0%, transparent 50%)',
          position: 'absolute',
          height: '100vh',
          bottom: 0,
          right: 0,
          width: '100%',
          marginRight: '-500px',
          opacity: 0.5,
        }}
      />
      <div className="row" style={{ position: 'relative' }}>
        <div
          className="col-md-5 col-12"
          style={{ right: 0, bottom: 0, zIndex: 1 }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              alignItems: 'center',
              height: '100%',
              marginLeft: '-50px',
              marginBottom: '-100px',
            }}
          >
            <img
              className="hide-mobile"
              src="./img/coffre.png"
              width={770}
              alt="coffre"
              style={{ maxWidth: '45vw' }}
            />
          </div>
        </div>
        <div className="col-md-7 col-12 px-4 mt-5">
          <div className="row  mt-5 mb-5 px-2">
            <div className="col-1 mt-5">
              {' '}
              <img src="./img/nature-ecology-leaf.svg" height={50} />
            </div>
            <div className="col-12">
              <h3 style={{ maxWidth: '500px' }} className="title green mt-5">
                {t('zeroEmissionTransport')}
              </h3>
              <p className="text green mt-5" style={{ maxWidth: '600px' }}>
                {t('innovativeAlternative')}
              </p>
              <p className="text green mt-3" style={{ maxWidth: '600px' }}>
                {t('brandingOpportunity')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
